var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_3829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4824 1.9184C15.7661 1.17526 14.5872 1.18904 13.8822 1.27986L13.995 0H3.02454L3.13733 1.27986C2.43229 1.18904 1.25347 1.17251 0.537142 1.9184C-0.0720157 2.5542 -0.162262 3.51754 0.272045 4.78364C1.05323 7.07087 3.80289 7.71768 5.14529 7.89933C6.07258 8.69736 7.26641 9.13769 8.50272 9.13769C9.73903 9.13769 10.9328 8.69736 11.8601 7.89933C13.2025 7.71768 15.9522 7.07362 16.7334 4.78364C17.1649 3.51754 17.0775 2.5542 16.4824 1.9184ZM1.6088 4.35427C1.35781 3.61938 1.3437 3.08541 1.56932 2.85146C1.86826 2.53494 2.72841 2.57623 3.26142 2.68082L3.42782 4.58546C3.47774 5.15007 3.62655 5.70214 3.86777 6.21763C2.92019 5.90662 1.93313 5.34788 1.59471 4.35427H1.6088ZM10.45 7.00481H7.00943V6.20937H8.23057V2.68908L7.1025 3.35515V2.47439L8.65641 1.5551H9.24302V6.20937H10.4585L10.45 7.00481ZM15.4248 4.35427C15.0864 5.34788 14.0993 5.90662 13.1518 6.21763C13.395 5.70269 13.5448 5.15042 13.5945 4.58546L13.7609 2.68082C14.3052 2.56246 15.171 2.53769 15.453 2.85146C15.6758 3.08541 15.6617 3.61938 15.4107 4.35427H15.4248Z",
    fill: "#5C5D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5005 9.73279C8.16036 9.73275 7.82049 9.71437 7.48242 9.67773V13.7623H9.5214V9.67773C9.18239 9.71436 8.84158 9.73274 8.5005 9.73279Z",
    fill: "#5C5D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6306 14.4004H5.14421C4.97293 14.4003 4.80707 14.459 4.67562 14.5661C4.54417 14.6733 4.45549 14.8221 4.42507 14.9866L3.62695 19.2666H13.1479L12.3497 14.9866C12.3193 14.8221 12.2306 14.6733 12.0992 14.5661C11.9677 14.459 11.8019 14.4003 11.6306 14.4004Z",
    fill: "#5C5D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22012 1.55469H8.63071L7.07961 2.47398V3.35474L8.21614 2.68867V6.20071H6.99219V7.0044H10.4356V6.20071H9.22012V1.55469Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_3829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 19.2667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.db6f6f7a9a68535b60a78362dba2537a.svg";
export { ForwardRef as ReactComponent };